import { render, staticRenderFns } from "./COACreate.vue?vue&type=template&id=1007bf76&scoped=true&lang=pug"
import script from "./COACreate.vue?vue&type=script&lang=js"
export * from "./COACreate.vue?vue&type=script&lang=js"
import style0 from "./COACreate.vue?vue&type=style&index=0&id=1007bf76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1007bf76",
  null
  
)

export default component.exports